<template>
  <div class="animated fadeIn">
    <div class="card shadow-sm border-0">
      <div class="card-header bg-dark text-white d-flex align-items-center justify-content-between py-2">
        <h6 class="mb-0"><font-awesome-icon icon="list" /> Office Payroll</h6>
        <b-button variant="success" size="sm" @click="openNew">
          <font-awesome-icon icon="plus" /> New Office Payroll
        </b-button>
      </div>
      <div class="card-body position-relative">
        <b-row class="mb-3">
          <b-col md="4">
            <b-form-select v-model="filter_group_id" :options="filterOptions" size="sm" @change="getAll"></b-form-select>
          </b-col>
          <b-col md="8">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-input-group-text class="bg-dark text-white"><font-awesome-icon icon="search" /></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input v-model="search" placeholder="Search period / voucher / check" debounce="400" @update="getAll"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>

        <b-table
          responsive hover striped bordered small
          :items="list.data" :fields="fields" :busy="loading" show-empty head-variant="dark"
        >
          <template v-slot:cell(group)="data">
            <b-badge variant="dark">{{ data.item.payroll_group ? data.item.payroll_group.name : '-' }}</b-badge>
          </template>
          <template v-slot:cell(period)="data">
            <strong>{{ data.item.date_from.other_formats.format_1 }}</strong> &mdash;
            <strong>{{ data.item.date_to.other_formats.format_1 }}</strong>
          </template>
          <template v-slot:cell(authorized)="data">
            {{ data.item.authorized ? data.item.authorized.name : '-' }}
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <b-button variant="primary" size="sm" @click="$router.push('/manpowers/office-payroll/' + data.item.id)">
                <font-awesome-icon icon="list" /> View
              </b-button>
            </div>
          </template>
        </b-table>

        <nav v-if="list.total > 0">
          <b-pagination :disabled="loading" @input="getAll" align="right"
            :total-rows="parseInt(list.total)" :per-page="parseInt(list.per_page)"
            v-model="list.current_page" class="mb-0"></b-pagination>
        </nav>
      </div>
    </div>

    <b-modal v-model="modal" centered size="md" :hide-footer="true" title="New Office Payroll">
      <b-form @submit.prevent="generate">
        <b-form-group label="Payroll Group" description="Each payroll group has its own cutoff; only its approved attendance is drafted.">
          <b-form-select v-model="form.payroll_group_id" :options="groupOptions" required></b-form-select>
        </b-form-group>
        <b-form-group label="Date From">
          <b-form-input type="date" v-model="form.date_from" required></b-form-input>
        </b-form-group>
        <b-form-group label="Date To">
          <b-form-input type="date" v-model="form.date_to" required></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="success" block :disabled="!form.payroll_group_id">
          <font-awesome-icon icon="search" /> Generate Draft
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import SwalMixin from '@/views/mixins/Swal.js'

  export default {
    name: 'OfficePayroll',
    mixins: [SwalMixin],
    data() {
      return {
        loading: true,
        search: '',
        groups: [],
        filter_group_id: null,
        list: { data: [], current_page: 1, total: 0, per_page: 1 },
        fields: [
          { key: 'id', label: '#' },
          { key: 'group', label: 'Payroll Group' },
          { key: 'period', label: 'Period' },
          { key: 'voucher_number', label: 'Voucher #' },
          { key: 'check_number', label: 'Check #' },
          { key: 'authorized', label: 'Authorized By' },
          { key: 'action', label: '' },
        ],
        modal: false,
        form: { payroll_group_id: null, date_from: '', date_to: '' },
      }
    },
    computed: {
      groupOptions() {
        return [{ value: null, text: 'Select payroll group', disabled: true }]
          .concat(this.groups.map(g => ({ value: g.id, text: g.name })));
      },
      filterOptions() {
        return [{ value: null, text: 'All payroll groups' }]
          .concat(this.groups.map(g => ({ value: g.id, text: g.name })));
      }
    },
    created() {
      this.getGroups();
      this.getAll();
    },
    methods: {
      getGroups() {
        this.axios.get('payroll-groups/options').then(response => {
          this.groups = response.data || [];
          if (this.groups.length === 1) this.form.payroll_group_id = this.groups[0].id;
        }).catch(error => console.log(error));
      },
      openNew() {
        if (!this.form.payroll_group_id && this.filter_group_id) this.form.payroll_group_id = this.filter_group_id;
        this.modal = true;
      },
      getAll() {
        this.loading = true;
        this.axios.get('office-payroll/all', { params: { page: this.list.current_page, per_page: 10, search: this.search, payroll_group_id: this.filter_group_id } })
          .then(response => { this.list = response.data; this.loading = false; })
          .catch(error => { console.log(error); this.loading = false; });
      },
      generate() {
        this.$router.push('/manpowers/office-payroll-draft/' + this.form.payroll_group_id + '/' + this.form.date_from + '/' + this.form.date_to);
      }
    }
  }
</script>
